import { inject, Injectable } from '@angular/core';
import { CustomResponse } from '../interfaces/custom-response.model';
import { Observable } from 'rxjs';
import { AppSettings } from '../app.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MainService {

  private apiEndpoint: string = AppSettings.settings.apiServer.backend;
  http = inject(HttpClient);

  constructor() { }

  newCashInvoice(): Observable<CustomResponse> {
    let url = `${this.apiEndpoint}/newcashinvoice`;

    return this.http.get<CustomResponse>(url);
  }

  newEcInvoice(): Observable<CustomResponse> {
    let url = `${this.apiEndpoint}/newecinvoice`;

    return this.http.get<CustomResponse>(url);
  }
}
